import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  GlgPopup,
  GlgSwitch,
  GlgRangeSlider,
  GlgSelect,
  GlgButton,
  GlgCheckbox,
  GlgTooltipIcon,
} from 'SharedComponents'
import { Row, Col } from 'react-flexbox-grid'
import _ from 'lodash'

class LeaderboardSlidePopupComponent extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isSaving: false,
      isFetchingTournamentData: false,
    }

    this.saveToDB = this.saveToDB.bind(this)
  }

  setInitialValues() {
    const {
      roundId,
    } = this.props

    const tournamentId = _.get(this.props, `tournamentsByRoundId[${roundId}][0].value`, 0)
    this.props.setTournament(tournamentId)

    const divisionIds = _.get(this.props, `divisionsBySpecId[${tournamentId}][${roundId}]`, []).map( division => division.value)
    this.props.setDivisionIds(divisionIds)

    const currentFlights = {}
    for (const divisionId in this.props.flightsByDivisionId) {
      if (divisionIds.includes(divisionId)) {
        currentFlights[String(divisionId)] = this.props.flightsByDivisionId[divisionId]
      }
    }
    this.props.setFlights(currentFlights)

    const backgroundOpacity = _.get(this.props, 'backgroundOpacity', 100)
    this.props.setBackgroundOpacity(backgroundOpacity)
  }

  componentDidUpdate(previousProps) {
    if (this.props.show) {
      if (!previousProps.show) {
        // if the popup just opened

        this.setState({
          ...this.state,
          isFetchingTournamentData: true,
        })

        if ( this.props.roundId === 0 ){
          const roundId = _.get(this.props, 'currentRoundId', _.get(this.props, 'rounds[0].value'))
          this.props.setRound(roundId)
        }

        $.ajax({
          url: this.props.paths.fetchTournamentsSelectData,
          type: 'POST',
          success: (response) => {
            this.props.setTournamentsData(response)
            if (!this.props.slideId) {
              this.setInitialValues()
            }
            this.setState({
              ...this.state,
              isFetchingTournamentData: false,
            })
          },
          error: () => {
          },
        })
      }

      if (previousProps.roundId && previousProps.roundId !== this.props.roundId){
        this.props.setTournament(_.get(this.props, `tournamentsByRoundId[${this.props.roundId}][0].value`, 0))
      } else if (previousProps.tournamentId && previousProps.tournamentId !== this.props.tournamentId) {
        const divisionIds = _.get(this.props, `divisionsBySpecId[${this.props.tournamentId}][${this.props.roundId}]`, []).map( division => division.value)
        this.props.setDivisionIds(divisionIds)

        const currentFlights = {}
        for (const divisionId in this.props.flightsByDivisionId) {
          if (divisionIds.includes(divisionId)) {
            currentFlights[String(divisionId)] = this.props.flightsByDivisionId[divisionId]
          }
        }
        this.props.setFlights(currentFlights)
      }/* else if (previousProps.divisionId && previousProps.divisionId !== this.props.divisionId) {
        this.props.setFlight(_.get(this.props, `flightsByDivisionId[${this.props.divisionId}][0].value`, 0))
      }*/
    }
  }

  saveToDB() {
    const {
      slideId,
      tournamentsByRoundId,
      roundId,
      tournamentId,
      divisionIds,
      flightIdsAndValuesByDivisionId,
      isVisible,
      backgroundImage,
      scrollRate,
      slidesCount,
      backgroundOpacity,
    } = this.props

    const slideDescription = tournamentsByRoundId[roundId].filter( tournament => tournament['value'] === tournamentId )[0]['label']
    const tournamentDisplayType = tournamentsByRoundId[roundId].filter( tournament => tournament['value'] === tournamentId )[0]['displayType']

    const slide = {
      slideId,
      position: slidesCount,
      visible: isVisible,
      type: 'leaderboard',
      description: slideDescription,
      animation: '',
      background: backgroundImage,
      scrollRate: scrollRate,
      settings: {
        roundId: roundId,
        tournamentId: tournamentId,
        divisionIds: divisionIds,
        flightIdsAndValuesByDivisionId: flightIdsAndValuesByDivisionId,
        displayType: tournamentDisplayType,
        backgroundOpacity: backgroundOpacity,
      },
    }

    this.setState({ isSaving: true })
    $.ajax({
      url: this.props.paths.saveSlide,
      type: 'POST',
      data: slide,
      success: (response) => {
        if (slideId) {
          this.props.updateSlide({
            id: slideId,
            type: 'leaderboard',
            description: slideDescription,
            visible: slide.visible,
          })
        } else {
          this.props.addSlide({
            id: response.id,
            type: 'leaderboard',
            description: slideDescription,
            visible: slide.visible,
          })
        }

        this.setState({ isSaving: false}, this.props.onClose)
      },
      error: () => {
      },
    })
  }

  render() {
    const {
      isSaving,
    } = this.state
    const {
      slideId,
      roundId,
      tournamentId,
      divisionIds,
      divisionsBySpecId,
      checkDivision,
      uncheckDivision,
      checkFlight,
      uncheckFlight,
      backgroundOpacity,
    } = this.props
    const saveButtonEnabled = !this.state.isFetchingTournamentData && tournamentId && (_.get(divisionsBySpecId, `[${this.props.tournamentId}][${this.props.roundId}].length`, 0) === 0 || _.get(divisionIds, 'length', 0) > 0)

    return (
      <GlgPopup
        title={ `${slideId ? (!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.edit_leaderboard_slide')) :
                             (!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.new_leaderboard_slide'))} ` }
        saveButtonText={ slideId ? (!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.update')) :
                                   (!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.add')) }
        saveButtonEnabled={ saveButtonEnabled }
        show={ this.props.show }
        modalClass={ 'leaderboard-popup' }
        manualClose={ true }
        onClose={ this.props.onClose }
        onSave={ this.saveToDB }
        isSaving={ isSaving }>
        <div id='slide_setup'>
          <div className='visible-switch justify-center'>
            <GlgSwitch
              id={ 'leaderboard-visible-switch' }
              text={ [ (!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.visible')),
                       (!window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.hidden')) ] }
              widthInPixels={ 80 }
              checked={ !!this.props.isVisible }
              onChange={ () => { this.props.setVisible(!this.props.isVisible) } } />
          </div>
          <ul className='no-padding'>
            <li className='form_row add-margin-top-10 add-padding-bottom-20'>
              <Row>
                <Col xs={ 12 }>
                  <div className='row popup-section-title'>
                    <Col xs={ 12 }>
                      { !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.tournament_data') }
                    </Col>
                  </div>
                  <div className='row popup-section no-padding-bottom'>
                    <Col className='no-padding-right' xs={ 12 }>
                      <Row className='vertical-align-items add-padding-top-5 add-padding-bottom-5'>
                        <Col xs={ 12 } md={ 4 } lg={ 3 }>
                          <div className='tournament-data-label'>
                            { !window.I18n ? '' : window.I18n.t('round').charAt(0)
                              .toUpperCase() + (!window.I18n ? '' : window.I18n.t('round').slice(1)) }
                          </div>
                        </Col>
                        <Col className='no-padding-right' xs={ 12 } md={ 8 } lg={ 9 }>
                          <GlgSelect
                            value={ `${this.props.roundId}` }
                            items={ this.props.rounds }
                            busy={ this.state.isFetchingTournamentData }
                            onChange={ (roundId) => { this.props.setRound(roundId) } } />
                        </Col>
                      </Row>
                      <Row className='vertical-align-items add-padding-top-5 add-padding-bottom-5'>
                        <Col xs={ 12 } md={ 4 } lg={ 3 }>
                          <div className='tournament-data-label'>
                            { !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.tournament') }
                            <GlgTooltipIcon tooltip={ !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.tournament_info') } />
                          </div>
                        </Col>
                        <Col className='no-padding-right' xs={ 12 } md={ 8 } lg={ 9 }>
                          <GlgSelect
                            value={ `${this.props.tournamentId}` }
                            busy={ this.state.isFetchingTournamentData }
                            items={ _.get(this.props, `tournamentsByRoundId[${this.props.roundId}]`, []) }
                            onChange={ (tournamentId) => { this.props.setTournament(tournamentId) } } />
                        </Col>
                      </Row>
                    </Col>
                  </div>
                </Col>
              </Row>
            </li>
            <li className='form_row add-margin-top-20 add-padding-bottom-20'>
              <Row>
                <Col xs={ 12 }>
                  <div className='row popup-section-title'>
                    <Col xs={ 6 } lg={ 3 }>
                      { _.get(divisionsBySpecId, `[${this.props.tournamentId}][${this.props.roundId}].length`, 0) > 0 && 
                        !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.divisions') }
                    </Col>
                    <Col xs={ 6 } lg={ 9 }>
                      { _.get(_.get(this.props, `tournamentsByRoundId[${this.props.roundId}]`, []).filter(tournament => tournament.value === this.props.tournamentId), '[0].competition', '').includes('Flight') &&
                        !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.flights')
                      }
                    </Col>
                  </div>
                  <div className='row'>
                    <Col xs={ 12 }>
                      {( () => {
                          const divisions = _.get(this.props, `divisionsBySpecId[${tournamentId}][${roundId}]`, [])
                          return divisions.map( ( division, index) => {
                            const isLastDivision = index === divisions.length - 1
                            return (
                              <Row className='no-margin' key={ division.value }>
                                <Col xs={ 6 } lg={ 3 } className={ 'no-padding-right' + (!isLastDivision ? ' col-underline' : '' ) }>
                                  <GlgCheckbox
                                    label={ `${division.label}` }
                                    value={ `${division.value}` }
                                    name="divisions[checkbox]"
                                    checked={ divisionIds.includes(division.value) }
                                    onChange={ (isChecked, value) => { isChecked ? checkDivision(value) : uncheckDivision(value) }} />
                                </Col>
                                {( (isLastDivision) => {
                                    const flights = _.get(_.get(this.props, `tournamentsByRoundId[${this.props.roundId}]`, []).filter(tournament => tournament.value === this.props.tournamentId), '[0].competition', '').includes('Flight') &&
                                                    _.get(this.props, `flightsByDivisionId[${division.value}]`, [])
                                    const showUnderline = flights !== false && !isLastDivision
                                    return (
                                      <Col xs={ 6 } lg={ 9 } className={'flights' + ( showUnderline ? ' col-underline' : '')}>
                                        { flights && flights.map( flight => {
                                          return (
                                            <GlgCheckbox
                                              label={ `${flight.label}` }
                                              value={ `${flight.value}` }
                                              key={ `${flight.value}` }
                                              name="flights[checkbox]"
                                              checked={
                                                _.get(this.props, `flightIdsAndValuesByDivisionId[${division.value}]`, [])
                                                    .map(flight => flight.value)
                                                    .includes(flight.value)
                                              }
                                              onChange={ (isChecked, value) => { isChecked ? checkFlight(division.value, flight) : uncheckFlight(division.value, value) }} />
                                          )
                                        })}
                                      </Col>
                                    )
                                  }
                                )(isLastDivision)}
                              </Row>
                            )
                          })
                        }
                      )()}
                    </Col>
                  </div>
                </Col>
              </Row>
            </li>
            <li className='form_row add-margin-top-20 add-padding-bottom-20'>
              <div className='row popup-section-title no-padding-bottom'>
                <Col xs={ 12 }>
                  { !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.content_transition') }
                </Col>
              </div>
              <div className='row popup-section vertical-align-items no-padding-bottom'>
                <Col xs={ 12 } sm={ 6 }>
                  <Row className='vertical-align-items add-padding-top-5 add-padding-bottom-5'>
                    <Col xs={ 12 } md={ 4 } lg={ 4 }>
                      { !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.scroll_rate') }
                    </Col>
                    <Col xs={ 12 } md={ 8 } lg={ 8 }>
                      <GlgRangeSlider
                        value={ this.props.scrollRate !== undefined ? this.props.scrollRate : 0 }
                        min={ 1 }
                        max={ 20 }
                        unit={ !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.seconds') }
                        onChange={ this.props.changeScrollRate } />
                    </Col>
                  </Row>
                </Col>
              </div>
            </li>
            <li className='form_row add-margin-top-20 no-padding-bottom no-border-bottom'>
              <div className='row popup-section-title no-padding-bottom'>
                <Col xs={ 12 }>
                  { 'Background' }
                </Col>
              </div>
              <div className='row popup-section vertical-align-items no-padding-bottom'>
                <Col xs={ 12 } sm={ 6 }>
                  <Row className='vertical-align-items add-padding-top-5 add-padding-bottom-5'>
                    <Col xs={ 12 } md={ 4 } lg={ 4 }>
                      { 'Opacity' }
                    </Col>
                    <Col xs={ 12 } md={ 8 } lg={ 8 }>
                      <GlgRangeSlider
                        value={ backgroundOpacity || 0 }
                        min={ 0 }
                        max={ 100 }
                        unit={ '%' }
                        onChange={ (opacity) => { this.props.setBackgroundOpacity(parseInt(opacity)) } } />
                    </Col>
                  </Row>
                </Col>
              </div>
            </li>
            <li className='form_row add-margin-top-10 add-padding-bottom-10 hidden'>
              <div className='row popup-section-title'>
                <Col xs={ 12 }>
                  { !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.background') }
                </Col>
              </div>
              <div className='row popup-section no-padding-bottom'>
                <Col xs={ 12 }>
                  <Row className='vertical-align-items add-padding-top-5 add-padding-bottom-5'>
                    <Col xs={ 5 } sm={ 4 } md={ 3 } lg={ 2 }>
                      <div className='background-container'>
                        <img src={DUMMY_BG[0]} />
                      </div>
                    </Col>
                    <Col xs={ 1 }>
                      <GlgButton
                        text={ !window.I18n ? '' : window.I18n.t('tv_shows.components.slide_popups.leaderboard_slide_popup.change') }
                        color={ 'white' }
                        onClick={ () => {} } />
                    </Col>
                  </Row>
                </Col>
              </div>
            </li>
          </ul>
        </div>
      </GlgPopup>
    )
  }
}

const DUMMY_BG = [ 'https://i.pinimg.com/originals/96/42/1a/96421a97b83034f52c410befe7cefa20.jpg' ]

LeaderboardSlidePopupComponent.propTypes = {
  paths: PropTypes.object.isRequired,
  slideId: PropTypes.string,
  type: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  rounds: PropTypes.array.isRequired,
  roundId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  setRound: PropTypes.func,
  tournamentsByRoundId: PropTypes.object,
  tournamentId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  setTournament: PropTypes.func,
  divisionIds: PropTypes.array,
  setDivisionIds: PropTypes.func,
  checkDivision: PropTypes.func,
  uncheckDivision: PropTypes.func,
  checkFlight: PropTypes.func,
  uncheckFlight: PropTypes.func,
  flightIdsAndValuesByDivisionId: PropTypes.object,
  setFlights: PropTypes.func,
  divisionsBySpecId: PropTypes.object,
  flightsByDivisionId: PropTypes.object,
  slidesCount: PropTypes.number.isRequired,
  isVisible: PropTypes.bool,
  scrollRate: PropTypes.number,
  backgroundImage: PropTypes.string,
  setVisible: PropTypes.func,
  changeScrollRate: PropTypes.func,
  addSlide: PropTypes.func.isRequired,
  updateSlide: PropTypes.func.isRequired,
  setTournamentsData: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  backgroundOpacity: PropTypes.number,
  setBackgroundOpacity: PropTypes.func.isRequired,
}

LeaderboardSlidePopupComponent.defaultProps = {
  divisionIds: [],
}

export default LeaderboardSlidePopupComponent
